<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="customerContainer">
    <div class="topPinkPart">
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_left1.png"
        alt=""
        class="cp1_414"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_left2.png"
        alt=""
        class="cp1_768"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_left3.png"
        alt=""
        class="cp1_1440"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_left4.png"
        alt=""
        class="cp1_1920"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_right1.png"
        alt=""
        class="cp2_414"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_right2.png"
        alt=""
        class="cp2_768"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_right3.png"
        alt=""
        class="cp2_1440"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_right4.png"
        alt=""
        class="cp2_1920"
      />

      <div class="partOne_m">
        <div class="p1MainTitle">What is Custom Nutrition？</div>
        <div class="p1SubTitle">定制营养是什么</div>
        <div class="p2MainTitle">私人定制 专属营养</div>
        <div class="p2SubTitle_pc">
          定制营养是针对不同用户的健康状况、体检指征、改善需求、生活习惯、饮食作息及处方药干扰等，<br />
          通过AI大数据检测报告和私人营养师管家为其量身定制的专属营养补充方案，<br />
          旨在通过精准的膳食补充，改善亚健康状态，全面满足您的健康提升需求。<br />
        </div>
        <div class="p2SubTitle_m">
          定制营养是针对不同用户的健康状况、体检指征、<br />改善需求、生活习惯、饮食作息及处方药干扰等，<br />
          通过AI大数据检测报告和私人营养师管家为其<br />量身定制的专属营养补充方案，<br />
          旨在通过精准的膳食补充，改善亚健康状态，<br />全面满足您的健康提升需求。<br />
        </div>
        <div class="p2SubTitle_m2">
          定制营养是针对不同用户的健康状况、体检指征、<br />改善需求、生活习惯、饮食作息及处方药干扰等，<br />
          通过AI大数据检测报告和私人营养师管家为其量身定制的专属营养补充方案，<br />
          旨在通过精准的膳食补充，改善亚健康状态，<br />全面满足您的健康提升需求。<br />
        </div>

        <div class="mainPic1">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_left.png"
            alt=""
            class="c1_left"
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_right.png"
            alt=""
            class="c1_right"
          />
        </div>
      </div>
      <div class="partOne_pc">
        <div class="p1MainTitle">What is Custom Nutrition？</div>
        <div class="p1SubTitle">定制营养是什么</div>
        <div class="p2MainTitle">私人定制 专属营养</div>
        <div class="p2SubTitle">
          定制营养是针对不同用户的健康状况、体检指征、改善需求、生活习惯、饮食作息及处方药干扰等，<br />
          通过AI大数据检测报告和私人营养师管家为其量身定制的专属营养补充方案，<br />
          旨在通过精准的膳食补充，改善亚健康状态，全面满足您的健康提升需求。<br />
        </div>

        <div class="mainPic1">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_left.png"
            alt=""
            class="c1_left"
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/c1_right.png"
            alt=""
            class="c1_right"
          />
        </div>
      </div>

      <div class="partTwo_m">
        <div class="p1MainTitle">Why Customize？</div>
        <div class="p1SubTitle">为什么要定制</div>
        <div class="p2MainTitle">没有完美的补剂 只有正确的选择</div>
        <div class="p2SubTitle_pc">
          健康状况因人而异，营养更需要精准补充。盲目跟风服用或随意选择销售排名靠前的补剂并不科学，<br />
          选当下阶段适合自己身体状况的才能达到理想效果。<br />
          既不能一刀切，也不要闭眼买，个性化营养方案才能做到标本兼治。<br />
        </div>
        <div class="p2SubTitle_m">
          健康状况因人而异，营养更需要精准补充。<br />盲目跟风服用或随意选择销售排名靠前的补剂并不科学，<br />
          选当下阶段适合自己身体状况的才能达到理想效果。<br />
          既不能一刀切，也不要闭眼买，<br />个性化营养方案才能做到标本兼治。<br />
        </div>
        <div class="p2SubTitle_m2">
          健康状况因人而异，营养更需要精准补充。盲目跟风服用或随意选择销售排名靠前的补剂并不科学，<br />
          选当下阶段适合自己身体状况的才能达到理想效果。<br />
          既不能一刀切，也不要闭眼买，个性化营养方案才能做到标本兼治。<br />
        </div>

        <div class="mainPic1">
          <img
            class="desPic"
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/pic2_txt_m.png"
            alt=""
          />
          <div class="desMain">Served 400,000+ Users</div>
          <div class="desSub">已服务400,000+用户</div>
          <div class="downLine"></div>
        </div>
      </div>
      <div class="partTwo_pc">
        <div class="p1MainTitle">Why Customize？</div>
        <div class="p1SubTitle">为什么要定制</div>
        <div class="p2MainTitle">没有完美的补剂 只有正确的选择</div>
        <div class="p2SubTitle">
          健康状况因人而异，营养更需要精准补充。盲目跟风服用或随意选择销售排名靠前的补剂并不科学，<br />
          选当下阶段适合自己身体状况的才能达到理想效果。<br />
          既不能一刀切，也不要闭眼买，个性化营养方案才能做到标本兼治。<br />
        </div>

        <div class="mainPic1">
          <div class="desMain">Served 400,000+ Users</div>
          <div class="desSub">已服务400,000+用户</div>
          <div class="downLine"></div>
        </div>
      </div>
    </div>

    <div class="grayPart">
      <div class="stepBox_pc">
        <div class="topPart">
          <div class="left">
            <div class="mainTitle">How to Custom Nutrition？</div>
            <div class="subTitle">如何定制</div>
          </div>
          <div class="right">
            中美权威问卷 三步获取报告
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/arr_d.png"
              alt=""
              class="arrIcon"
            />
          </div>
        </div>

        <div class="stepItemBox">
          <div class="item">
            <div class="tag">STEP 1</div>

            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step1.png"
              alt=""
              class="pic pic_1920"
            />
             <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step1_1440.png"
              alt=""
              class="pic pic_1440"
            />
            <div class="des1">3分钟AI营养测评</div>
            <div class="des2">
              中美权威营养测评，从13个需求、8个维度全面评估身体状况
            </div>
          </div>
          <div class="item">
            <div class="tag">STEP 2</div>

            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step2.png"
              alt=""
              class="pic pic_1920"
            />
             <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step2_1440.png"
              alt=""
              class="pic pic_1440"
            />
            <div class="des1">获取精准补剂方案</div>
            <div class="des2">
              超1,000,000+营养数据支持，大数据算法，生成100%匹配需求的健康报告
            </div>
          </div>
          <div class="item">
            <div class="tag">STEP 3</div>

            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step3.png"
              alt=""
              class="pic pic_1920"
            />
             <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step3_1440.png"
              alt=""
              class="pic pic_1440"
            />
            <div class="des1">定制专属每日一袋</div>
            <div class="des2">保税仓快速发货，顺丰直邮，每日轻松补充</div>
          </div>
        </div>
      </div>
      <div class="stepBox_m">
        <div class="mainTitle">How to Custom Nutrition？</div>
        <div class="subTitle">如何定制</div>
        <div class="moreTitle">
          中美权威问卷 三步获取报告
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/arr_d.png"
            alt=""
            class="arrIcon"
          />
        </div>

        <div class="stepItemBox">
          <div class="outerItem">
            <div class="tag">STEP 1</div>

            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/customer/step1.png"
                alt=""
                class="pic pic_414"
              />
              <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step1_1440.png"
              alt=""
              class="pic pic_768"
            />
              <div class="des1">3分钟AI营养测评</div>
              <div class="des2">
                中美权威营养测评，从13个需求、8个维度全面评估身体状况
              </div>
            </div>
          </div>

          <div class="outerItem">
            <div class="tag">STEP 2</div>
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/customer/step2.png"
                alt=""
                class="pic pic_414"
              />
              <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step2_1440.png"
              alt=""
              class="pic pic_768"
            />
              <div class="des1">获取精准补剂方案</div>
              <div class="des2">
                超1,000,000+营养数据支持，大数据算法，生成100%匹配需求的健康报告
              </div>
            </div>
          </div>
          <div class="outerItem">
            <div class="tag">STEP 3</div>
            <div class="item no_r_margin">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/customer/step3.png"
                alt=""
                class="pic pic_414"
              />
              <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step3_1440.png"
              alt=""
              class="pic pic_768"
            />
              <div class="des1">定制专属每日一袋</div>
              <div class="des2">保税仓快速发货，顺丰直邮，每日轻松补充</div>
            </div>
          </div>
        </div>
      </div>

      <div class="dapeiExample_m">
        <div class="mainTitle">Customer Snapshots</div>
        <div class="subTitle">搭配案例</div>
        <div class="exampleList">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/al1.png"
            alt=""
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/al2.png"
            alt=""
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/al3.png"
            alt=""
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/al4.png"
            alt=""
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/al5.png"
            alt=""
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/al6.png"
            alt=""
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/customer/al7.png"
            alt=""
          />
        </div>
      </div>

      <div class="dapeiExample_pc">
        <div class="mainTitle">Customer Snapshots</div>
        <div class="subTitle">搭配案例</div>
        <Example></Example>
      </div>

      <div class="tryBox_m">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/customer/dingdingPic.png"
          alt=""
          class="dingdingPic"
        />
        <div class="txt">Starting a Healthy Life</div>
        <div class="btn" @click="toMake($event, 0)">
          Try NUTRIPACKS Now
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/arr_r_w_index.png"
            class="arrR"
          />
        </div>
      </div>

      <div class="tryBox_pc">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/customer/dingdingPic.png"
          alt=""
          class="dingdingPic"
        />
        <div class="right">
          <div class="txt">Starting a Healthy Life</div>
          <div class="btn" @click="toMake($event, 0)">
            Try NUTRIPACKS Now
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/arr_r_w_index.png"
              class="arrR"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 定制弹窗 -->
    <CodePupop
      ref="myPupop"
      :position="position"
      :left="left"
      :top="top"
    ></CodePupop>
  </div>
</template>

<script>
import Example from "../components/example.vue";
import CodePupop from "../components/codePupop.vue";

export default {
  name: "productDetail",
  components: {
    Example,
    CodePupop,
  },
  data: () => ({
    info: "",
    gid: "",
    maxheight: "600px",
    eng_name: "",
    goods_name: "",
    showtan: false,
    showtanl: false,
    showtanl2: false,
    showtan2: false,
    showmore: false,
    hasshow: false,
    cha: 0,
    reportinfo: "",
    prodetail: "",
    publicurl:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/",
    bimg: "",

    position: "bottom",
    left: 0,
    top: 0,
  }),
  updated() {
    var th = this.$refs.thisheight;
    if (th.scrollHeight > 500) {
      this.showmore = true;
    }
  },
  mounted() {
    var that = this;
    that.gid = this.$route.query.id;
    // this.$ajax
    //   .post(this.API.api.apiurl.getGoodsInfo, {
    //     goods_id: that.$route.query.id,
    //   })
    //   .then((res) => {
    //     var data = res.data.data;
    //     if (res.data.code == 0) {
    //       var goods_detail = data.goods_detail;
    //       var sprice = goods_detail.shop_price;
    //       var dayprice = Number(sprice * goods_detail.day_use).toFixed(2);
    //       goods_detail.dayprice = dayprice;
    //       data.goods_detail = goods_detail;
    //       var iu = data.goods_img_text.big_img;
    //       //console.log(iu)
    //       that.bimg = iu;
    //       var goods_units = data.goods_detail.goods_unit;
    //       // goods_units.forEach((item,index)=>{
    //       // 	var eng = item.unit_eng
    //       // 	var name = item.unit_name
    //       // 	var ar = name.split(eng)
    //       // 	if (eng) {
    //       // 		goods_units[index].zh = ar[1]
    //       // 	} else {
    //       // 		goods_units[index].zh = name
    //       // 	}
    //       // })
    //       console.log(data.goods_detail.goods_unit);
    //       data.goods_detail.goods_unit = goods_units;
    //       that.prodetail = data;
    //       that.eng_name = data.goods_detail.eng_name;
    //       that.goods_name = data.goods_detail.goods_name;
    //     } else {
    //       that.$Message.info("错误：" + res.data.message);
    //     }
    //   })
    //   .catch((error) => {
    //     that.$Message.info(error);
    //   });
  },
  methods: {
    toMake(event, type) {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let clickX = event.clientX; // 相对于视口的X坐标
      let clickY = event.clientY; // 相对于视口的Y坐标
      // 判断水平方向
      const horizontal = clickX < screenWidth / 2 ? "左" : "右";
      // 判断垂直方向
      const vertical = clickY < screenHeight / 2 ? "上" : "下";
      console.log(clickX, clickY);
      switch (horizontal + vertical) {
        case "左上":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 + 1 - 5;
          break;
        case "左下":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 - 8.5 + 5;
          break;
        case "右上":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 + 1.5 - 5;
          break;
        case "右下":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 - 9 + 5;
          break;
      }
      this.left = clickX;
      this.top = clickY;

      this.$refs.myPupop.showPupop(type);
    },
    hasshowtrue() {
      let scrollHeightOne = window.pageYOffset;
      this.cha = scrollHeightOne;
      this.maxheight = "inherit";
      this.hasshow = true;
      this.showmore = true;
      this.$forceUpdate();
    },
    hasshowfalse() {
      this.maxheight = "600px";
      this.hasshow = false;
      this.showmore = true;
      window.scrollTo(0, this.cha);
      this.$forceUpdate();
    },
    tlshowtan2() {
      if (this.showtanl2 == true) {
        //console.log('')
      } else {
        this.showtan2 = false;
      }
    },
    lshowtan2() {
      var that = this;
      this.showtanl2 = true;
      setTimeout(function () {
        that.showtanl2 = false;
      }, 700);
    },
    tlshowtan() {
      if (this.showtanl == true) {
        //console.log('')
      } else {
        this.showtan = false;
      }
    },
    lshowtan() {
      var that = this;
      this.showtanl = true;
      setTimeout(function () {
        that.showtanl = false;
      }, 700);
    },
    goBack() {
      if (this.$route.query.way == "report") {
        this.$router.go(-1);
      }
    },
    gohome() {
      this.$router.push({
        path: "pro_detail",
      });
    },
    gounitdetail() {
      //console.log(id)
      this.showtan2 = true;
    },
    goreportdetail(id) {
      var that = this;
      this.$ajax
        .post(this.API.api.apiurl.getReportInfo, {
          id: id,
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 0) {
            that.reportinfo = data.data;
            that.showtan = true;
          } else {
            that.$Message.info("错误：" + data.msg);
          }
        })
        .catch((error) => {
          that.$Message.info(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.no_r_margin {
  margin-right: 0 !important;
}
//mobile414
@media screen and (max-width: 767px) {
  .customerContainer {
    overflow-x: hidden;
    margin-top: 1.38rem;
    .topPinkPart {
      height: 46.7391rem;
      background: #f6f4f1;
      position: relative;
      padding-top: 1.0145rem;
      .cp1_768 {
        display: none;
      }
      .cp1_1440 {
        display: none;
      }
      .cp1_1920 {
        display: none;
      }
      .cp2_768 {
        display: none;
      }
      .cp2_1440 {
        display: none;
      }
      .cp2_1920 {
        display: none;
      }
      .cp1_414 {
        width: 3.4783rem;
        height: 3.913rem;
        position: absolute;
        left: -0.628rem;
        top: 3.6715rem;
      }
      .cp2_414 {
        width: 2.7536rem;
        height: 4.3961rem;
        position: absolute;
        right: -0.628rem;
        top: 3.6715rem;
      }
      .partOne_m {
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.7246rem;
          color: #1a1a1a;
          line-height: 0.8696rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.3382rem;
          color: #1a1a1a;
          line-height: 0.4348rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.2415rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.3382rem;
          color: #1a1a1a;
          line-height: 0.4831rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 3.7198rem;
        }
        .p2SubTitle_pc {
          display: none;
        }
        .p2SubTitle_m2 {
          display: none;
        }
        .p2SubTitle_m {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2899rem;
          color: #1a1a1a;
          line-height: 0.6763rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.2415rem;
        }
        .mainPic1 {
          width: 7.1014rem;
          height: 11.6908rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg1_m.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 0.9662rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          padding: 1.9324rem 0;
          .c1_left {
            width: 5.6522rem;
            height: 3.5266rem;
          }
          .c1_right {
            width: 6.1353rem;
            height: 3.5266rem;
          }
        }
      }
      .partOne_pc {
        display: none;
      }
      .partTwo_pc {
        display: none;
      }
      .partTwo_m {
        margin-top: 1.9324rem;
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.7246rem;
          color: #1a1a1a;
          line-height: 0.8696rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.3382rem;
          color: #1a1a1a;
          line-height: 0.4348rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.2415rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.3382rem;
          color: #1a1a1a;
          line-height: 0.4831rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.9662rem;
        }
        .p2SubTitle_pc {
          display: none;
        }
        .p2SubTitle_m2 {
          display: none;
        }
        .p2SubTitle_m {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2899rem;
          color: #1a1a1a;
          line-height: 0.6763rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.4348rem;
        }
        .mainPic1 {
          width: 7.1014rem;
          height: 11.6908rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg2_m.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 0.9662rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          position: relative;
          .desPic {
            width: 6.0386rem;
            height: 1.3527rem;
          }
          .desMain {
            display: none;
          }
          .desSub {
            display: none;
          }
          .downLine {
            height: 2.8986rem;
            border-left: 0.0242rem solid #000000;
            position: absolute;
            bottom: -2.8986rem;
          }
        }
      }
    }
    .grayPart {
      background-color: #fff;
      padding-top: 2.5121rem;
      .stepBox_pc {
        display: none;
      }
      .stepBox_m {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.7246rem;
          color: #1a1a1a;
          line-height: 0.8696rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.3382rem;
          color: #1a1a1a;
          line-height: 0.4348rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.2415rem;
        }
        .moreTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.3382rem;
          color: #1a1a1a;
          line-height: 0.4348rem;
          font-style: normal;
          margin-top: 0.5797rem;
          .arrIcon {
            width: 0.2222rem;
            height: 0.1111rem;
            margin-left: 0.0926rem;
          }
        }
        .stepItemBox {
          width: 100%;
          margin-top: 0.9662rem;
          display: flex;
          justify-content: space-between;
          overflow-y: hidden;
          overflow-x: scroll;
          padding: 0 0.5797rem;
          .outerItem {
            .tag {
              width: 1.5459rem;
              height: 0.5797rem;
              background: #ffffff;
              border-radius: 0.4348rem;
              border: 0.0242rem solid #000000;
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.2899rem;
              color: #000000;
              line-height: 0.5797rem;
              margin-bottom: 0.4831rem;
            }
            .item {
              position: relative;
              width: 5.2174rem;
              height: 7.2464rem;
              border-radius: 0.1932rem;
              border: 0.0242rem solid #e5e5e5;
              box-sizing: border-box;
              padding: 0.2899rem;
              margin-right: 0.2415rem;
              .pic {
                width: 4.686rem;
                height: 4.686rem;
                border-radius: 0.1932rem;
                object-fit: cover;
              }
              .pic_768 {
                display: none;
              }
              .des1 {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 0.3382rem;
                color: #141414;
                line-height: 0.3382rem;
                text-align: left;
                font-style: normal;
                margin-top: 0.4831rem;
              }
              .des2 {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 0.2899rem;
                color: #141414;
                line-height: 0.4348rem;
                text-align: left;
                font-style: normal;
                margin-top: 0.1932rem;
              }
            }
            // .item:last-child {
            //   margin-right: 0px;
            // }
            // .item:nth-child(2) {
            //   .tag {
            //     left: -51px;
            //   }
            // }
            // .item:nth-child(3) {
            //   .tag {
            //     left: -96px;
            //   }
            // }
          }
        }
        .stepItemBox::-webkit-scrollbar {
          display: none;
        }
      }
      .dapeiExample_pc {
        display: none;
      }
      .dapeiExample_m {
        background: #f6f4f1;
        margin-top: 2.2222rem;
        padding-top: 1.9324rem;
        padding-bottom: 1.9324rem;
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.7246rem;
          color: #141414;
          line-height: 1.4493rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.3382rem;
          color: #000000;
          line-height: 0.4348rem;
          text-align: center;
          font-style: normal;
        }
        .exampleList {
          padding: 0 0.5797rem;
          display: flex;
          overflow-y: hidden;
          overflow-x: scroll;
          margin-top: 1.4493rem;
          img {
            width: 7.6812rem;
            height: 10.2415rem;
            margin-right: 0.4348rem;
            border-radius: 0.1932rem;
          }
          img:last-child {
            margin-right: 0;
          }
        }
        .exampleList::-webkit-scrollbar {
          display: none;
        }
      }
      .tryBox_pc {
        display: none;
      }
      .tryBox_m {
        margin-left: 50%;
        transform: translateX(-50%);
        width: 29.5894rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1.9324rem 0.5797rem;

        .dingdingPic {
          // width: 8.8406rem;
          // height: 8.8889rem;
          width: calc(100vw - 1.16rem);
          height: auto;
          border-radius: 0.1932rem;
        }
        .txt {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.7246rem;
          color: #141414;
          line-height: 1.4493rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.8696rem;
        }
        .btn {
          width: 5.8937rem;
          height: 1.0628rem;
          background: #c25e4d;
          border-radius: 0.9662rem;
          display: flex;
          justify-content: center;
          align-items: center;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 0.3382rem;
          color: #ffffff;
          line-height: 0.4348rem;
          text-align: left;
          font-style: normal;

          margin-top: 0.3382rem;
          .arrR {
            width: 0.37rem;
            height: 0.3rem;
            margin-left: 0.22rem;
          }
        }
        .btn:hover {
          background-color: #d35e4f;
        }
      }
    }
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .customerContainer {
    overflow-x: hidden;
    margin-top: 1.38rem;

    .topPinkPart {
      background: #f6f4f1;
      position: relative;
      padding-top: 1.8519rem;
      padding-bottom: 1.8519rem;
      .cp1_414 {
        display: none;
      }
      .cp1_1440 {
        display: none;
      }
      .cp1_1920 {
        display: none;
      }
      .cp2_414 {
        display: none;
      }
      .cp2_1440 {
        display: none;
      }
      .cp2_1920 {
        display: none;
      }
      .cp1_768 {
        width: 3.8148rem;
        height: 4.1481rem;
        position: absolute;
        left: -0.5556rem;
        top: 4.1852rem;
      }
      .cp2_768 {
        width: 2.6667rem;
        height: 4.2037rem;
        position: absolute;
        right: -0.5556rem;
        top: 4.1852rem;
      }
      .partOne_m {
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #1a1a1a;
          line-height: 0.963rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #333333;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 1.4815rem;
        }
        .p2SubTitle_pc {
          display: none;
        }
        .p2SubTitle_m {
          display: none;
        }
        .p2SubTitle_m2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2593rem;
          color: #1a1a1a;
          line-height: 0.5185rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.2593rem;
        }
        .mainPic1 {
          width: 12.5926rem;
          height: 4.7407rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg1.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 1.4815rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.963rem 0;
          padding-left: 1.7037rem;
          padding-right: 1.2593rem;
          .c1_left {
            width: 4.4444rem;
            height: 2.7778rem;
          }
          .c1_right {
            width: 4.8148rem;
            height: 2.7778rem;
          }
        }
      }
      .partOne_pc {
        display: none;
      }
      .partTwo_pc {
        display: none;
      }
      .partTwo_m {
        margin-top: 2.2222rem;
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #1a1a1a;
          line-height: 0.963rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #333333;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: left;
          font-style: normal;
          text-align: center;
          margin-top: 1.4815rem;
        }
        .p2SubTitle_pc {
          display: none;
        }
        .p2SubTitle_m {
          display: none;
        }
        .p2SubTitle_m2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2593rem;
          color: #1a1a1a;
          line-height: 0.5185rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .mainPic1 {
          width: 12.5926rem;
          height: 4.7407rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg2.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 1.4815rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          position: relative;
          .desPic {
            display: none;
          }
          .desMain {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.6667rem;
            color: #ffffff;
            line-height: 0.8148rem;
            text-align: right;
            font-style: normal;
          }
          .desSub {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.2963rem;
            color: #ffffff;
            line-height: 0.4074rem;
            text-align: right;
            font-style: normal;
            margin-top: 0.1481rem;
          }
          .downLine {
            height: 3.7037rem;
            border-left: 1px solid #000000;
            position: absolute;
            bottom: -3.7037rem;
          }
        }
      }
    }
    .grayPart {
      background-color: #fff;
      padding-top: 2.963rem;
      .stepBox_pc {
        display: none;
      }
      .stepBox_m {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #1a1a1a;
          line-height: 0.963rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.1481rem;
        }
        .moreTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.8889rem;
          .arrIcon {
            width: 0.3333rem;
            height: 0.1852rem;
            margin-left: 0.1481rem;
          }
        }
        .stepItemBox {
          width: 100%;
          margin-top: 1.4815rem;
          display: flex;
          justify-content: space-between;
          overflow-y: hidden;
          overflow-x: scroll;
          padding: 0 0.8148rem;
          .outerItem {
            margin-right: 0.3333rem;
            .tag {
              width: 1.7778rem;
              height: 0.6667rem;
              background: #ffffff;
              border-radius: 0.3333rem;
              border: 0.0185rem solid #000000;
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.3333rem;
              color: #000000;
              line-height: 0.4444rem;
              text-align: left;
              font-style: normal;
              margin-bottom: 0.6667rem;
            }
            .item {
              position: relative;
              width: 7.4074rem;
              height: 9.5185rem;
              border-radius: 0.1481rem;
              border: 0.0185rem solid #e5e5e5;
              box-sizing: border-box;
              padding: 0.3704rem;
              .pic {
                width: 6.6667rem;
                height: 6.6667rem;
              }
              .pic_414 {
                display: none;
              }
              .des1 {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 0.3333rem;
                color: #141414;
                line-height: 0.4444rem;
                text-align: left;
                font-style: normal;
                margin-top: 0.5185rem;
              }
              .des2 {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 0.2593rem;
                color: #141414;
                line-height: 0.4444rem;
                text-align: left;
                font-style: normal;
                margin-top: 0.1481rem;
              }
            }
          }
          .outerItem:last-child {
            margin-right: 0px;
          }
        }
        .stepItemBox::-webkit-scrollbar {
          display: none;
        }
      }
      .dapeiExample_pc {
        display: none;
      }
      .dapeiExample_m {
        background: #f6f4f1;
        margin-top: 1.8519rem;
        padding-top: 1.8519rem;
        padding-bottom: 1.8519rem;
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #141414;
          line-height: 1.1111rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #000000;
          line-height: 0.5556rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.4444rem;
        }
        .exampleList {
          padding: 0 0.7407rem;
          display: flex;
          overflow-y: hidden;
          overflow-x: scroll;
          margin-top: 1.4815rem;
          img {
            width: 5.5556rem;
            height: 7.4074rem;
            margin-right: 0.2963rem;
            border-radius: 0.2222rem;
          }
          img:last-child {
            margin-right: 0;
          }
        }
        .exampleList::-webkit-scrollbar {
          display: none;
        }
      }
      .tryBox_pc {
        display: none;
      }
      .tryBox_m {
        margin-left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1.8519rem 0.8148rem;

        .dingdingPic {
          // width: 12.5926rem;
          // height: 12.5926rem;
          width: calc(100vw - 1.62rem);
          height: auto;
          border-radius: 0.1481rem;
        }
        .txt {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #141414;
          line-height: 1.1111rem;
          text-align: center;
          font-style: normal;
          margin-top: 1.4815rem;
          width: 9.2593rem;
        }
        .btn {
          width: 4.7407rem;
          height: 1.2963rem;
          background: #c25e4d;
          border-radius: 0.7407rem;
          display: flex;
          justify-content: center;
          align-items: center;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 0.2963rem;
          color: #ffffff;
          line-height: 0.4074rem;
          text-align: left;
          font-style: normal;

          margin-top: 1.1111rem;
          .arrR {
            width: 0.3rem;
            height: 0.2rem;
            margin-left: 0.19rem;
          }
        }
        .btn:hover {
          background-color: #d35e4f;
        }
      }
    }
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .customerContainer {
    // margin-top:1.85rem;
    .topPinkPart {
      background: #f6f4f1;
      position: relative;
      padding-top: 1.8519rem;
      padding-bottom: 2.2222rem;
      .cp1_414 {
        display: none;
      }
      .cp1_768 {
        display: none;
      }
      .cp1_1920 {
        display: none;
      }
      .cp2_414 {
        display: none;
      }
      .cp2_768 {
        display: none;
      }
      .cp2_1920 {
        display: none;
      }
      .cp1_1440 {
        width: 6.1111rem;
        height: 6.4074rem;
        position: absolute;
        left: -0.7407rem;
        top: 4.2963rem;
      }
      .cp2_1440 {
        width: 4.3333rem;
        height: 6.9259rem;
        position: absolute;
        right: -0.9259rem;
        top: 4.2963rem;
      }
      .partOne_m {
        display: none;
      }
      .partOne_pc {
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #1a1a1a;
          line-height: 0.963rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #333333;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 1.1111rem;
        }
        .p2SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2593rem;
          color: #1a1a1a;
          line-height: 0.5185rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .mainPic1 {
          width: 22.8889rem;
          height: 8.5926rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg1.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 2.2222rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
          justify-content: space-between;
          padding-left: 3.3333rem;
          padding-right: 2.6852rem;
          .c1_left {
            width: 7.7778rem;
            height: 4.8519rem;
          }
          .c1_right {
            width: 8.4259rem;
            height: 4.8333rem;
          }
        }
      }
      .partTwo_m {
        display: none;
      }
      .partTwo_pc {
        margin-top: 2.2222rem;
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #1a1a1a;
          line-height: 0.963rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #333333;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 1.1111rem;
        }
        .p2SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2593rem;
          color: #1a1a1a;
          line-height: 0.5185rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .mainPic1 {
          width: 22.8889rem;
          height: 8.5926rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg2.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 2.2222rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
          justify-content: space-between;
          padding-left: 3.3333rem;
          padding-right: 2.6852rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          .downLine {
            position: absolute;
            height: 4.037rem;
            border-left: 1px solid #000000;
            bottom: -4.037rem;
          }
          .desPic {
            display: none;
          }
          .desMain {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.8148rem;
            color: #ffffff;
            line-height: 0.963rem;
            text-align: right;
            font-style: normal;
          }
          .desSub {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.4074rem;
            color: #ffffff;
            line-height: 0.5556rem;
            margin-top: 0.1481rem;
          }
        }
      }
    }
    .grayPart {
      // background-color: #f0f2f5;
      background-color: #fff;

      padding-top: 2.6296rem;
      padding-bottom: 2.2222rem;
      .stepBox_m {
        display: none;
      }
      .stepBox_pc {
        .topPart {
          margin-left: 50%;
          transform: translateX(-50%);
          width: 22.8889rem;
          display: flex;
          align-items: start;
          justify-content: space-between;
          .left {
            .mainTitle {
              font-family: MADEEvolveSans, MADEEvolveSans;
              font-weight: bold;
              font-size: 0.8148rem;
              color: #1a1a1a;
              line-height: 0.963rem;
              text-align: left;
              font-style: normal;
            }
            .subTitle {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.4074rem;
              color: #1a1a1a;
              line-height: 0.5556rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.1481rem;
            }
          }
          .right {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.4074rem;
            color: #1a1a1a;
            line-height: 0.5556rem;
            text-align: left;
            font-style: normal;
            .arrIcon {
              width: 0.2593rem;
              height: 0.1852rem;
              margin-left: 0.1852rem;
            }
          }
        }
        .stepItemBox {
          margin-left: 50%;
          transform: translateX(-50%);
          width: 22.8889rem;
          margin-top: 2.8148rem;
          padding-bottom: 2.2222rem;
          display: flex;
          justify-content: space-between;
          .item {
            position: relative;
            width: 7.4074rem;
            height: 9.5185rem;
            border-radius: 0.1481rem;
            border: 0.0185rem solid #e5e5e5;
            box-sizing: border-box;
            padding: 0.3704rem 0.2963rem;
            .tag {
              position: absolute;
              top: -1.3333rem;
              left: 0;
              width: 1.7778rem;
              height: 0.6667rem;
              background: #ffffff;
              border-radius: 0.3333rem;
              border: 0.0185rem solid #000000;
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.3333rem;
              color: #000000;
              line-height: 0.4444rem;
              text-align: left;
              font-style: normal;
            }
            .pic {
              width: 6.6667rem;
              height: 6.6667rem;
            }
            .pic_1920{
              display: none;
            }
            .des1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.3333rem;
              color: #141414;
              line-height: 0.4444rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.5185rem;
            }
            .des2 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.2593rem;
              color: #141414;
              line-height: 0.4259rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.1481rem;
            }
          }
        }
      }
      .dapeiExample_m {
        display: none;
      }
      .dapeiExample_pc {
        background: #f6f4f1;
        padding-top: 2.2222rem;
        padding-bottom: 2.8889rem;
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #141414;
          line-height: 1.1111rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #000000;
          line-height: 0.5556rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.1852rem;
          margin-bottom: 1.6667rem;
        }
      }
      .tryBox_m {
        display: none;
      }
      .tryBox_pc {
        margin-left: 50%;
        transform: translateX(-50%);
        width: 23.1481rem;
        display: flex;
        align-items: center;
        padding-top: 2.963rem;
        .dingdingPic {
          width: 10.7407rem;
          height: 10.7407rem;
          margin-right: 2.5926rem;
        }
        .right {
          .txt {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.8148rem;
            color: #141414;
            line-height: 1.1111rem;
            text-align: left;
            font-style: normal;
          }
          .btn {
            width: 4.6667rem;
            height: 1.1111rem;
            background: #c25e4d;
            border-radius: 0.7407rem;
            display: flex;
            justify-content: center;
            align-items: center;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.2963rem;
            color: #ffffff;
            line-height: 0.4074rem;
            text-align: left;
            font-style: normal;

            margin-top: 0.7778rem;
            .arrR {
              width: 0.3rem;
              height: 0.2rem;
              margin-left: 0.19rem;
            }
          }
          .btn:hover {
            background-color: #d35e4f;
          }
        }
      }
    }
  }
}
//大web1920
@media screen and (min-width: 1920px) {
  .customerContainer {
    .topPinkPart {
      height: 38.2778rem;
      background: #f6f4f1;
      position: relative;
      padding-top: 1.8519rem;
      .cp1_414 {
        display: none;
      }
      .cp1_768 {
        display: none;
      }
      .cp1_1440 {
        display: none;
      }
      .cp2_414 {
        display: none;
      }
      .cp2_768 {
        display: none;
      }
      .cp2_1440 {
        display: none;
      }
      .cp1_1920 {
        width: 6.8148rem;
        height: 6.4074rem;
        position: absolute;
        left: 0;
        top: 4.2963rem;
      }
      .cp2_1920 {
        width: 5.6667rem;
        height: 6.9259rem;
        position: absolute;
        right: 0;
        top: 4.2963rem;
      }
      .partOne_m {
        display: none;
      }
      .partOne_pc {
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #1a1a1a;
          line-height: 0.963rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #333333;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 1.1111rem;
        }
        .p2SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2593rem;
          color: #1a1a1a;
          line-height: 0.5185rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .mainPic1 {
          width: 22.8889rem;
          height: 8.5926rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg1.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 2.2222rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
          justify-content: space-between;
          padding-left: 3.3333rem;
          padding-right: 2.7037rem;
          .c1_left {
            width: 7.7778rem;
            height: 4.8519rem;
          }
          .c1_right {
            width: 8.4444rem;
            height: 4.8519rem;
          }
        }
      }
      .partTwo_m {
        display: none;
      }
      .partTwo_pc {
        margin-top: 2.2222rem;
        .p1MainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #1a1a1a;
          line-height: 0.963rem;
          text-align: right;
          font-style: normal;
          text-align: center;
        }
        .p1SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #333333;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .p2MainTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.4074rem;
          color: #1a1a1a;
          line-height: 0.5556rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 1.1111rem;
        }
        .p2SubTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.2593rem;
          color: #1a1a1a;
          line-height: 0.5185rem;
          text-align: right;
          font-style: normal;
          text-align: center;
          margin-top: 0.1481rem;
        }
        .mainPic1 {
          width: 22.8889rem;
          height: 8.5926rem;
          background-image: url(https://cdn-file.xiaojudai.cn/web/dist/customer/customer_bg2.png);
          background-size: cover;
          background-repeat: no-repeat;
          margin-top: 2.2222rem;
          margin-left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
          justify-content: space-between;
          padding-left: 3.3333rem;
          padding-right: 2.7037rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .desPic {
            display: none;
          }
          .desMain {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.8148rem;
            color: #ffffff;
            line-height: 0.963rem;
            text-align: right;
            font-style: normal;
          }
          .desSub {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.4074rem;
            color: #ffffff;
            line-height: 0.5556rem;
            margin-top: 0.1481rem;
          }
        }
      }
    }
    .grayPart {
      // background-color: #f0f2f5;
      background-color: #fff;
      padding-top: 2.7407rem;
      padding-bottom: 2.2222rem;
      .stepBox_m {
        display: none;
      }
      .stepBox_pc {
        padding-bottom: 2.2222rem;

        .topPart {
          margin-left: 50%;
          transform: translateX(-50%);
          width: 25.9259rem;
          display: flex;
          align-items: start;
          justify-content: space-between;
          .left {
            .mainTitle {
              font-family: MADEEvolveSans, MADEEvolveSans;
              font-weight: bold;
              font-size: 0.8148rem;
              color: #1a1a1a;
              line-height: 0.963rem;
              text-align: left;
              font-style: normal;
            }
            .subTitle {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.4074rem;
              color: #1a1a1a;
              line-height: 0.5556rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.1481rem;
            }
          }
          .right {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.4074rem;
            color: #1a1a1a;
            line-height: 0.5556rem;
            text-align: left;
            font-style: normal;
            .arrIcon {
              width: 0.3333rem;
              height: 0.1852rem;
              margin-left: 0.1481rem;
            }
          }
        }
        .stepItemBox {
          margin-left: 50%;
          transform: translateX(-50%);
          width: 25.9259rem;
          margin-top: 2.8148rem;
          display: flex;
          justify-content: space-between;
          .item {
            position: relative;
            width: 8.3704rem;
            height: 9.5185rem;
            border-radius: 0.1481rem;
            border: 0.0185rem solid #e5e5e5;
            box-sizing: border-box;
            padding: 0.3704rem 0.2963rem;
            .tag {
              position: absolute;
              top: -1.3333rem;
              left: 0;
              width: 1.7778rem;
              height: 0.6667rem;
              background: #ffffff;
              border-radius: 0.3333rem;
              border: 0.0185rem solid #000000;
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.3333rem;
              color: #000000;
              line-height: 0.4444rem;
              text-align: left;
              font-style: normal;
            }
            .pic {
              width: 7.7778rem;
              height: 6.6667rem;
            }
            .pic_1440{
              display: none;
            }
            .des1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.3333rem;
              color: #141414;
              line-height: 0.4444rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.5185rem;
            }
            .des2 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.2593rem;
              color: #141414;
              line-height: 0.4444rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.1481rem;
            }
          }
          .item:nth-child(2) {
            .tag {
              left: -0.8889rem;
            }
          }
          .item:nth-child(3) {
            .tag {
              left: -2.037rem;
            }
          }
        }
      }
      .dapeiExample_m {
        display: none;
      }
      .dapeiExample_pc {
        background: #f6f4f1;
        padding-top: 2.2222rem;
        padding-bottom: 2.8889rem;
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.8148rem;
          color: #141414;
          line-height: 1.1111rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.4074rem;
          color: #000000;
          line-height: 0.5556rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.1852rem;
          margin-bottom: 1.6667rem;
        }
      }
      .tryBox_m {
        display: none;
      }
      .tryBox_pc {
        margin-left: 50%;
        transform: translateX(-53%);
        width: 24.0741rem;
        display: flex;
        align-items: center;
        padding-top: 2.963rem;
        .dingdingPic {
          width: 12.2593rem;
          height: 12.2593rem;
          margin-right: 2.5926rem;
        }
        .right {
          .txt {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.8148rem;
            color: #141414;
            line-height: 1.1111rem;
            text-align: left;
            font-style: normal;
          }
          .btn {
            width: 4.6667rem;
            height: 1.1111rem;
            background: #c25e4d;
            border-radius: 0.7407rem;
            display: flex;
            justify-content: center;
            align-items: center;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.2963rem;
            color: #ffffff;
            line-height: 0.4074rem;
            text-align: left;
            font-style: normal;

            margin-top: 0.7778rem;
            .arrR {
              width: 0.3rem;
              height: 0.2rem;
              margin-left: 0.19rem;
            }
          }
          .btn:hover {
            background-color: #d35e4f;
          }
        }
      }
    }
  }
}
</style>
